module.exports = __webpack_public_path__ + "static/media/basketball_girls_sell.6b0df95e.png";